import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiEpBillingRecurringPayment {
}
ApiEpBillingRecurringPayment.cancel = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/recurring-payment/${req.path.id}/cancel`,
    method: "POST",
});
ApiEpBillingRecurringPayment.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/recurring-payment/`,
    method: "GET",
    query: req === null || req === void 0 ? void 0 : req.query,
});
ApiEpBillingRecurringPayment.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/recurring-payment/${req.path.id}`,
    method: "GET",
});
//# sourceMappingURL=recurring_payment.js.map